var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.216,
    height: 8.589,
    viewBox: "0 0 11.216 8.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M21.661,13.211l-.917-.943a.2.2,0,0,0-.146-.062h0a.189.189,0,0,0-.146.063L14.1,18.67l-2.312-2.312a.2.2,0,0,0-.292,0l-.927.927a.208.208,0,0,0,0,.3L13.484,20.5a.922.922,0,0,0,.609.3.967.967,0,0,0,.6-.286H14.7l6.964-7A.223.223,0,0,0,21.661,13.211Z",
    transform: "translate(-10.505 -12.206)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5f33c34e0b57973389743218fdf6c63c.svg";
export { ForwardRef as ReactComponent };